import * as oldRoutes from 'App/routes'
import * as newRoutes from 'mammoth/routes'
import i18next from 'i18next'

type OLD_PATHS = (typeof oldRoutes)[keyof typeof oldRoutes][number]['path']
type NEW_PATH = (typeof newRoutes)[keyof typeof newRoutes][number]['path']

export const to = (path: NEW_PATH | OLD_PATHS, rest = '') => `/${i18next.language || ':language'}/${path}${rest}`
